import { formatListValue, listItemMsg } from '@/shared/components/FormattedListValue';
// The app's own list translations, so tenant translations of templates and roles apply.
export const templateName = (intl, taskTemplateId, fallback) => intl.formatMessage(listItemMsg('tasktemplate', taskTemplateId, fallback));
export const profileName = (intl, profile) => formatListValue({ list: 'employeeprofile', id: profile, fallback: `${profile}`, intl });
